import React, { } from 'react';
import { InputNumber, Form, Input, Collapse } from 'antd';
import { createUseStyles } from 'react-jss'
import AbstractCollection from '../../../common/AbstractCollection';
import { useSelector } from 'react-redux';
import { MetaColumns } from 'fennec-ui';
import { Model } from 'fennec-ui';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { useEffect } from 'react';
import ObjectContextDescription from '../../../fedance-ui/ObjectContextDescription';
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

const { Panel } = Collapse;

const useStyles = createUseStyles({
    tabs: {
        '& .ant-tabs-nav': {
            margin: "0 0 6px 0"
        },
        '& .ant-tabs-tab + .ant-tabs-tab': {
            margin: "0 0 0 20px"
        },
        '& .ant-tabs-nav .ant-tabs-tab': {
            padding: "5px 0",
            fontSize: "13px"
        }
    },
    collapse: {
        '& .ant-collapse-content > .ant-collapse-content-box': {
            padding: "0px"
        },
        '&.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow': {
            top: "-2px",
            left: "9px"
        },
        '&.ant-collapse > .ant-collapse-item > .ant-collapse-header': {
            padding: "4px 10px",
            paddingLeft: "25px",
            fontWeight: "300"
        },
        '&.ant-collapse .filtered .filtered-header-wrapper .ant-card-body': {
            padding: "7px",
        }
    },
    fieldName: {
        fontWeight: "300"
    },
    fieldValue: {
        fontStyle: "italic",
        color: "black",
        fontWeight: "300"
    },
    pricetableColumn: {
        '.ant-table-thead > tr > th&': {
            fontSize: "12px",
            textAlign: "right",
        },
        'td&': {
            fontSize: "12px",
            color: "#8d8d8d",
            textAlign: "right",
        }
    },
    lower: {
        color: "red"
    },
    grater: {
        color: "blue"
    }
})

export default function IzmenitUslugiKlientu(props) {
    const classes = useStyles()
    const { auth, object, form, parentObject } = props;
    const meta = useSelector(state => state.meta);
    const metaObj = (name) => {
        return meta[name];
    }

    return (
        <>
            {/* <div style={{ paddingBottom: "10px" }}><span>Номенклатура: {object.yacheikaUsluga.nazvanie}</span></div> */}
            <ObjectContextDescription object={object?.yacheikaUsluga} title={"Позиция"} />
            <Form
                style={{ paddingBottom: "15px" }}
                form={form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    ...object
                }}
            >
                {/* <Form.Item label="Название"
                    hidden={true}
                    name="nazvanie"
                    rules={[{ required: true, message: 'Пожалуйста, укажите название!' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item label="Описание"
                    hidden={true}
                    name="opisanie"
                    rules={[{ required: false, message: 'Пожалуйста, укажите описание!' }]}
                >
                    <Input />
                </Form.Item> */}
                <Form.Item label="Количество"
                    name="kolichestvo"
                    rules={[{ required: true, message: 'Пожалуйста, укажите количество!' }]}
                >
                    <InputNumber />
                </Form.Item>
                <hr></hr>
                <div>ВЫБЕРИТЕ ОДНО ПОЛЕ ИЗ ДВУХ 👇🏼</div>
                <Form.Item label="Доля позиции в услуге, выраженная в процентах от общей стоимости услуги"
                    name="protsentObshcheiSummiUslugiNaMeropriyatii"
                    rules={[{ required: false, message: 'Пожалуйста, укажите процент!' }]}
                >
                    <InputNumber />
                </Form.Item>
                <Form.Item label="Доля позиции в услуге, выраженная в рублях"
                    name="rubleiOtObshcheiSummiUslugiNaMeropriyatii"
                    rules={[{ required: false, message: 'Пожалуйста, укажите сумму!' }]}
                >
                    <InputNumber />
                </Form.Item>
                <hr></hr>
            </Form>
            {console.log(metaObj("UslugiKlientuKategorii"))}
            <Collapse className={classes.collapse} accordion>
                <Panel header="Категории в которые можно зарегистрироваться" key="service-available">
                    <AbstractCollection
                        auth={auth}
                        source={"/api/uslugiklientukategorii/byuslugaklienta/" + object.ID}
                        collectionActions={() => []}
                        modelActions={(item, index) => [
                            // /api/uslugiklientu/setdostupnaregistratsiya
                        ]}
                        columns={
                            MetaColumns(
                                ["Kategoriya", "DostupnaRegistratsiya"].map((e, idx) => metaObj("UslugiKlientuKategorii").properties.find(n => e === n.name)),
                                meta,
                                {
                                    DostupnaRegistratsiya: {
                                        method: "POST",
                                        path: "/api/uslugiklientu/setdostupnaregistratsiya",
                                        mutation: "update",
                                        onValues: (values, context) => ({
                                            ...values,
                                            dostupnaRegistratsiya: !values.dostupnaRegistratsiya
                                        }),
                                        onClose: ({ unlock, close }, context) => unlock(),
                                    }
                                })
                        }
                        form={Model}
                        meta={metaObj("UslugiKlientuKategorii").properties}
                    />
                </Panel>
            </Collapse>
        </>
    );
}
